export function ChefHat({
  size = 24,
  className,
  color = "currentColor",
  strokeWidth = 2,
  useGradient = false,
  ...props
}: {
  size?: number;
  className?: string;
  color?: string;
  strokeWidth?: number;
  useGradient?: boolean;
  [key: string]: any;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 18 19"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      {useGradient && (
        <defs>
          <linearGradient
            id="chefHatGradient"
            x1="14.8536"
            y1="3.79867"
            x2="8.05462"
            y2="16.9472"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D4D4D4" />
            <stop offset="0.495" stopColor="#9D9D9D" />
            <stop offset="1" stopColor="#D4D4D4" />
          </linearGradient>
        </defs>
      )}
      <path
        d="M9 0C7.32316 0 5.84526 1.08439 5.37158 2.66C4.86947 2.43756 4.33895 2.31707 3.78947 
					2.31707C2.78444 2.31707 1.82058 2.70766 1.10991 3.40292C0.399247 4.09818 0 5.04115 0 
					6.02439C0 7.71122 1.17474 9.18488 2.84211 9.61122V16.2195H15.1579V9.61122C16.8253 9.18488 
					18 7.71122 18 6.02439C18 5.04115 17.6008 4.09818 16.8901 3.40292C16.1794 2.70766 15.2156 
					2.31707 14.2105 2.31707C13.6611 2.31707 13.1305 2.43756 12.6284 2.66C12.1547 1.08439 10.6768 
					0 9 0ZM8.52632 8.34146H9.47368V14.8293H8.52632V8.34146ZM5.68421 
					10.1951H6.63158V14.8293H5.68421V10.1951ZM11.3684 10.1951H12.3158V14.8293H11.3684V10.1951ZM2.84211 
					17.1463V18.0732C2.84211 18.319 2.94192 18.5547 3.11958 18.7285C3.29725 18.9024 3.53822 19 3.78947 
					19H14.2105C14.4618 19 14.7028 18.9024 14.8804 18.7285C15.0581 18.5547 15.1579 18.319 15.1579 18.0732V17.1463H2.84211Z"
        fill={useGradient ? "url(#chefHatGradient)" : color}
        stroke="none"
      />
    </svg>
  );
}
